<div
  v-if="show_session_prompt"
  class="modal fade show d-block"
  role="dialog"
  aria-modal="true"
  aria-labelledby="session-timeout-title"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2">
        <h2 id="session-timeout-title" class="modal-title h5 mb-0">Continue your session?</h2>
      </div>
      <div class="modal-body pt-0">
        <p class="mb-0 text-body-secondary">Your session is inactive. You will be logged out in {{ countdown_minutes }} if there is no response.</p>
      </div>
      <div class="modal-footer border-0 pt-2">
        <button type="button" class="btn btn-outline-secondary" @click="logout_due_to_inactivity">
          Logout
        </button>
        <button type="button" class="btn btn-primary" @click="continue_session">
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
<div v-if="show_session_prompt" class="modal-backdrop fade show"></div>
